import React, { useEffect } from 'react'
import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setLodgingGroupList, setLodgingGroupRoomCategory, setRoomLodgingGroupList } from '../../../store/slices/groupFiles/groupFilesSlice';
import { getLoadingGroup, getLodgingGroupRoomCategory, getRoomlodgingGroupList } from '../../../store/slices/groupFiles/thunks';
import { AddLodgingRoomCategory } from './AddLodgingRoomCategory';
import { LodgingRoomCategoryDetails } from './LodgingRoomCategoryDetails';

export const LodgingRoomCategory = ({ groupFile }) => {
  const dispatch = useDispatch();
  const { lodgingGroupRoomCategory } = useSelector((state) => state.groupFiles);
  const [addLodgingRoomCategory, setAddLodgingRoomCategory] = useState(false);

  useEffect(() => {
    if (groupFile.id) {
      dispatch(getLoadingGroup(groupFile.id))
    }

    return () => {
      dispatch(setLodgingGroupList([]));
    }
  }, [groupFile.id])
  
  useEffect(() => {
    if (groupFile.id) {
      dispatch(getLodgingGroupRoomCategory(groupFile.id))
    }

    return () => {
      dispatch(setLodgingGroupRoomCategory([]));
    }
  }, [groupFile.id])

  return (
    <div>
      <button className="btn btn-light btn-icon" style={{ marginTop: 20 }}
        onClick={() => setAddLodgingRoomCategory(true)} >Agregar Categoria</button>
      <AddLodgingRoomCategory groupFile={groupFile} isOpen={addLodgingRoomCategory} setIsOpen={setAddLodgingRoomCategory} />

      {
        lodgingGroupRoomCategory.map(lodging => (
          <LodgingRoomCategoryDetails key={lodging.id} lodging={lodging} groupFile={groupFile} />
        ))
      }
    </div>
  )
}
